module.exports = __webpack_public_path__ + "img/lbt_3.5bae5680.jpg";